import React from "react";
import styles from "./BankDetailsModal.module.scss";
import Modal from "../Modal/Modal";

const BankDetailsModal = ({ show, handleClose, bankDetails }) => {
  return (
    <>
      <Modal
        show={show}
        handleClose={handleClose}
        backdrop="static"
        className={styles.match_modal}
        title="Bank Details"
        hideCloseBtn
      >
        <div className={styles.bodyData}>
          <p>
            <strong>Bank Name:</strong> {bankDetails?.bank_name}
          </p>
          <p>
            <strong>Account Number:</strong> {bankDetails?.account_number}
          </p>
          <p>
            <strong>IFSC Code:</strong> {bankDetails?.ifsc_code}
          </p>
          <p>
            <strong>Account Type:</strong> {bankDetails?.account_type}
          </p>
          <p>
            <strong>Routing Number:</strong> {bankDetails?.routing_number}
          </p>
        </div>
      </Modal>
    </>
  );
};

export default BankDetailsModal;
